import { useEffect } from 'react';
import PagePreloader from '@/Components/navigation/PagePreloader';

function normalizeRedirect(path: string | null): string {
  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return '/';
  }

  return path === '/dashboard' ? '/' : path;
}

export default function AuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || params.get('access');
    const farmaciaId = params.get('farmacia_id') || params.get('empresa_id');
    const redirect = normalizeRedirect(params.get('redirect'));

    if (token) {
      localStorage.setItem('auth_token', token);
      localStorage.removeItem('farmacia_id');
      localStorage.removeItem('empresa_id');

      if (farmaciaId) {
        localStorage.setItem('farmacia_id', farmaciaId);
        localStorage.setItem('empresa_id', farmaciaId);
      }

      window.location.replace(redirect);
      return;
    }

    window.location.replace('/login');
  }, []);

  return <PagePreloader active={true} spinner={true} />;
}
